import { render, staticRenderFns } from "./EditModalFavorites.vue?vue&type=template&id=19b055dc&"
import script from "./EditModalFavorites.vue?vue&type=script&lang=js&"
export * from "./EditModalFavorites.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports